import { IPeriod, OutagePeriod, Period, TimeGridPeriod } from "./Period"

export class TimeGrid {
    
    periods: TimeGridPeriod[] = [];
    period_duration:number=10;
    

    static create_outages(planningPeriod: IPeriod) {
        
        const outages: OutagePeriod[] = []
        
        const d = new Date(planningPeriod.startTime)

        while (d.getTime()<planningPeriod.endTime.getTime()) {
            d.setHours(9)
            outages.push( new OutagePeriod(d,30,"przerwa pracownicza" ))
            d.setHours(9+8)
            outages.push( new OutagePeriod(d,30,"przerwa pracownicza" ))
            d.setHours(9+8+8)
            outages.push( new OutagePeriod(d,30,"przerwa pracownicza" ))
        }
        return outages;
      }

    prepare(planningPeriod: IPeriod, outages: IPeriod[]) {
        
        const remaining_first_period_minutes = (this.period_duration - (planningPeriod.startTime.getMinutes() % this.period_duration)) % this.period_duration;
        const first_period = new TimeGridPeriod(planningPeriod.startTime, remaining_first_period_minutes)
        const overlapping_periods = Period.overlapping_periods(first_period,outages)
        if (overlapping_periods.length>0) { first_period.available=0; first_period.text = overlapping_periods[0].text; }
        this.periods.push(first_period);

        const start_time = new Date(planningPeriod.startTime)
        start_time.setMinutes(planningPeriod.startTime.getMinutes() + remaining_first_period_minutes);

        while (start_time.getTime()<planningPeriod.endTime.getTime()) {
            const p = new TimeGridPeriod(new Date(start_time), this.period_duration)
            const overlapping_periods = Period.overlapping_periods(p, outages)
            if (overlapping_periods.length>0) { 
                p.available=0; 
                p.text = overlapping_periods[0].text; 
            }
            this.periods.push(p);
            start_time.setMinutes(start_time.getMinutes() + this.period_duration);
        }
    }

}